import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-e0c92cd8")

_pushScopeId("data-v-e0c92cd8")
const _hoisted_1 = { class: "flex flex-row pt-4 pb-2" }
const _hoisted_2 = { class: "font-semibold text-20px mr-4 text-black-lp-200 title-layout" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-between my-2"
}
const _hoisted_4 = { class: "text-gray-lp-300" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HeaderFilterBar = _resolveComponent("HeaderFilterBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ManualAssignModal = _resolveComponent("ManualAssignModal")!
  const _component_TransferPickupModal = _resolveComponent("TransferPickupModal")!
  const _component_WidgetDownload = _resolveComponent("WidgetDownload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("img", {
          src: _imports_0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "w-5 mr-3 cursor-pointer",
          alt: "arrow-left"
        }),
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("pickupDashboard.tabAllPickUp")), 1)
      ]),
      _createVNode(_component_HeaderFilterBar, {
        dateRange: _ctx.dateRange,
        "onUpdate:dateRange": [
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateRange = $event)),
          _ctx.onChangeDate
        ],
        search: _ctx.search,
        "onUpdate:search": [
          _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event)),
          _ctx.onSearch
        ],
        shipmentType: _ctx.shipmentTyp,
        "onUpdate:shipmentType": _cache[4] || (_cache[4] = ($event: any) => (_ctx.shipmentTyp = $event)),
        downloadButtonText: _ctx.$t('pickupDashboard.downloadDataPickUp'),
        disableDownloadButton: _ctx.isLoading,
        onDownload: _ctx.onDownloadPickUp,
        onFilter: _ctx.onChoseShipmentType
      }, null, 8, ["dateRange", "search", "shipmentType", "downloadButtonText", "disableDownloadButton", "onDownload", "onUpdate:search", "onUpdate:dateRange", "onFilter"]),
      _createVNode("div", {
        class: ["flex flex-row items-center gap-4 border-b", { 'mb-4': !_ctx.selectedRows.length }]
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsSummary, (tab, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: index,
            to: tab.name,
            exactActiveClass: "text-red-lp-100 border-b-2 border-red-lp-100",
            class: "px-4 py-2 cursor-pointer font-semibold text-gray-500 hover:text-red-lp-100",
            onClick: ($event: any) => (_ctx.onHandleTabAction(tab.name))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(tab.title), 1)
            ]),
            _: 2
          }, 1032, ["to", "onClick"]))
        }), 128))
      ], 2),
      (_ctx.selectedRows.length)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("p", _hoisted_4, [
              _createVNode("b", null, _toDisplayString(_ctx.selectedRows.length), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.buttonProps.selectedCountKey)), 1)
            ]),
            _createVNode(_component_LpButton, {
              title: _ctx.$t(_ctx.buttonProps.titleKey),
              outline: "",
              iconV2: "",
              iconLeft: _ctx.buttonProps.icon,
              iconColor: "white",
              textColor: "white",
              compact: "",
              customClass: "px-4 py-2.5 bg-red-lp-300",
              iconGroupHoverColor: "white",
              onClick: _ctx.onHandleButtonAction
            }, null, 8, ["title", "iconLeft", "onClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_ManualAssignModal, {
      show: _ctx.showAssignModal,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAssignModal = $event)),
      selectedSellers: _ctx.selectedSellersForAssign,
      onAssignSuccess: _ctx.handleModalSuccess
    }, null, 8, ["show", "selectedSellers", "onAssignSuccess"]),
    _createVNode(_component_TransferPickupModal, {
      show: _ctx.showTransferModal,
      selectedSellers: _ctx.selectedSellers,
      sourceCourierId: _ctx.sourceCourierId,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTransferModal = $event)),
      onRemoveSeller: _ctx.handleRemoveSeller,
      onTransferSuccess: _ctx.handleModalSuccess
    }, null, 8, ["show", "selectedSellers", "sourceCourierId", "onRemoveSeller", "onTransferSuccess"]),
    _createVNode(_component_WidgetDownload)
  ], 64))
})